import { useEffect, useState } from 'react';

/**
 * A clock that re-renders its caller, so time-dependent UI changes on its own
 * (#577).
 *
 * Staleness is the one property of a drone that becomes true when *nothing*
 * happens. Every other field on the map changes because a frame arrived; a
 * drone becomes stale precisely because none did, so a component that only
 * re-renders on new telemetry would show the last live marker forever — which
 * is the bug.
 *
 * @param intervalMs how often to tick. Well under STALE_AFTER_MS so the
 *   transition lands within a few seconds of the threshold rather than a
 *   minute after it.
 */
export const useNow = (intervalMs = 15_000): number => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);

  return now;
};
